import type { IntlShape } from 'react-intl'

import { HoldingsFilters, OrderByProps } from 'api/HoldingsService'
import { SortDirection } from "types/graphql-schemas/graphql"

export const getLabelForSortCriteria = (
  intl: IntlShape,
  orderBy: OrderByProps,
  direction: SortDirection
): string => {
  if (direction === SortDirection.Asc) {
    return {
      name: intl.formatMessage({
        id: 'companyList.nameSortAsc',
      }),
      last_update_at: intl.formatMessage({
        id: 'companyList.lastUpdateSort',
      }),

      portfolio_type: intl.formatMessage({
        id: 'companyList.portfolioTypeSortAsc',
      }),
    }[orderBy]
  }

  return {
    name: intl.formatMessage({
      id: 'companyList.nameSortDesc',
    }),

    last_update_at: intl.formatMessage({
      id: 'companyList.lastUpdateSort',
    }),

    portfolio_type: intl.formatMessage({
      id: 'companyList.portfolioTypeSortDesc',
    }),
  }[orderBy]
}

export const getParameters = (activeFilters) => {
  const filters: HoldingsFilters = {}
  const tagsName: string[] = []

  activeFilters.forEach((activeFilter) => {
    if (activeFilter?.dataSetName === 'name') {
      filters.name = activeFilter.value
    }

    if (activeFilter?.dataSetName === 'industry') {
      if (filters.industryId) {
        filters.industryId?.push(activeFilter.value)
      } else {
        filters.industryId = [activeFilter.value]
      }
    }

    if (activeFilter?.dataSetName === 'sector') {
      if (filters.sectorId) {
        filters.sectorId?.push(activeFilter.value)
      } else {
        filters.sectorId = [activeFilter.value]
      }
    }

    if (activeFilter?.dataSetName === 'country') {
      if (filters.countryId) {
        filters.countryId.push(activeFilter.value)
      } else {
        filters.countryId = [activeFilter.value]
      }
    }

    if (activeFilter?.dataSetName === 'province') {
      if (filters.legalProvinceId) {
        filters.legalProvinceId.push(activeFilter.value)
      } else {
        filters.legalProvinceId = [activeFilter.value]
      }
    }

    if (activeFilter?.dataSetName === 'legalStructure') {
      if (filters.legalStructureId) {
        filters.legalStructureId.push(activeFilter.value)
      } else {
        filters.legalStructureId = [activeFilter.value]
      }
    }

    if (activeFilter?.dataSetName === 'portfolio') {
      filters.holdingName = activeFilter.value
    }

    if (activeFilter.dataSetName === 'keyword') {
      filters.text = activeFilter.value
    }

    if (activeFilter.dataSetName === 'tag') {
      tagsName.push(activeFilter.value)
    }
  })

  return { filters, tagsName }
}
